import { ReactElement } from "react";
import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../../../components";
import { Alert } from "../../../../components/alert/Alert";
import { useDashboardContext } from "../../../../components/dashboard/Dashboard.shared";
import { NavigationBar } from "../../../../components/navigation/NavigationBar";
import {
  PRODUCT_LIST,
  PRODUCT_LIST_CATEGORY,
} from "../../../../constants/routes";
import { useEvents } from "../../../../hooks";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useProductCreate } from "../../../../hooks/api/v2/product/useProductCreate";
import ProductItemFormV3 from "./ProductItemFormV3";

export function ProductAddV2(): ReactElement {
  const navigate = useNavigate();
  const { isTwoPanel } = useDashboardContext();
  const { track } = useEvents();

  const productMutateCreate = useProductCreate();

  return (
    <>
      <NavigationBar
        title={"Create a new product..."}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={isTwoPanel ? undefined : () => navigate(PRODUCT_LIST)}
      />
      <div className="mx-auto p-2 lg:py-10">
        {productMutateCreate.isPending ? (
          <SpinnerLegacy />
        ) : (
          <>
            {productMutateCreate.isError && (
              <Alert
                type={"error"}
                message={
                  apiV2AssertError(productMutateCreate.error)?.response?.data
                    .message ?? "Unknown error"
                }
              />
            )}
            <ProductItemFormV3
              onSubmit={(product) => {
                productMutateCreate.mutate(product, {
                  onSuccess: async (product) => {
                    await track("Product Created", {
                      ...product,
                    });
                    navigate(
                      `${PRODUCT_LIST_CATEGORY.href({ productId: product.id })}?new=true`,
                    );
                  },
                });
              }}
            />
          </>
        )}
      </div>
    </>
  );
}
